<div class="contenitore">
  <div class="btn">
    <button class="btn-close" mat-dialog-close>
      <mat-icon svgIcon="mat:close"></mat-icon>
    </button>
  </div>
  <h1><img src="../../../assets/img/thunderbolt_outline_violet.svg">{{item.type}}</h1>
  <div #planDescriptionHTML class="custom-description" [innerHTML]="item.description"></div>
</div>
